import React, { memo, useCallback } from "react";
import { imageBasePath } from "../../../../../Utils/config";

const LocationCard = ({ image, name, price, setLocation, location }) => {
  const activeStyle = "border-2 border-[#AD6800] bg-[#FFFBE6]";
  const setLocationHandler = useCallback(() => {
    setLocation({
      name,
      price,
    });
  }, [name, price, setLocation]);
  return (
    <div className="group flex flex-col justify-center items-center">
      <div
        className={`w-[193px] h-[193px] cursor-pointer rounded-2xl border-solid border-[#BFBFBF] hover:border-[#AD6800] hover:bg-[#FFFBE6] flex flex-col justify-end items-center ${
          location?.name?.includes(name) ? activeStyle : " border"
        }`}
        onClick={setLocationHandler}
      >
        <div>
          <img src={imageBasePath + image} alt={name} />
        </div>
        <p
          className={`font-font-Titillium font-normal group-hover:font-bold text-[20px] leading-[30px] text-center tracking-[0.0063em] text-[#141414] uppercase mt-6 mb-4 ${
            !!location?.name?.includes(name) && "font-bold"
          }`}
        >
          {name}
        </p>
      </div>
      <p
        className={`font-font-Titillium font-normal group-hover:font-bold text-[20px] leading-[30px] text-center tracking-[0.0063em] text-[#141414] uppercase mt-4 ${
          !!location?.name?.includes(name) && "font-bold"
        }`}
      >
        {`£` + price}
      </p>
    </div>
  );
};

export default memo(LocationCard);
